import BitesApi from '../index';

interface ITicketBody {
  subject: string;
  content: string;
  email: string;
}
export const sendContactUsTicket = (body: ITicketBody) => BitesApi.post('/contact_us/', body);
